
import React, { useState, useEffect, useContext, useRef } from "react";


import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
// import Sidebar from "../components/dashboard/sidebar";
import SideMenu from "../student/SideMenu";
import { useNavigate, Link, useLocation } from "react-router-dom";
import tmdbApi from "../../api/tmdbApi";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import TableLoader from "../../components/tableLoader";
import Loader from "../../components/loader";
import DataTable from 'react-data-table-component';
import parse from "react-html-parser";
import SessionPopup from "../../pages/SessionPopup";
import Tooltip from '@mui/material/Tooltip'
import { toPlainText, useImageCloudfront, getTimeLeft } from "./useShareDetails";
import ShareImageViewer from "./ShareImageViewer";
import ShareThumb from "./ShareThumb";
import { getPreviewCandidates, getViewerTileSource } from "./shareImage";
import ShareLinkModal from "./ShareLinkModal";


const ShareHistory = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [data, setData] = useState([]);

    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message

    // const [deleteShow, setDeleteShow] = useState(false);
    // const [deleteUserId, setDeleteUserId] = useState(false);
    // const [deleteBlocked, setDeleteBlocked] = useState(false);

    let id = localStorage.getItem("userId");

    const [totalRows, setTotalRows] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);
    const [usersearch, setUserSearch] = useState("");
    const [activeSearch, setActiveSearch] = useState(""); // search term the loaded rows belong to
    const requestIdRef = useRef(0);
    const imageCloudfront = useImageCloudfront();
    const [viewerImage, setViewerImage] = useState(null); // { tileSource, title } of the image open in the viewer
    const [now, setNow] = useState(Date.now()); // ticks every minute so "Expires In" counts down
    const [shareRow, setShareRow] = useState(null); // row open in the share link popup

    useEffect(() => {
        const timer = setInterval(() => setNow(Date.now()), 60000);
        return () => clearInterval(timer);
    }, []);


    // const [isLoading, setIsLoading] = useState(false);
    const { isLoading, setIsLoading, userData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity, isRestricted } = useContext(contentContext)
 

    // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setUserSearch("")
        }
    }, [prevRoute]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);
    const isHtml = (str = "") => /<\/?[a-z][\s\S]*>/i.test(str);

    const stripHtml = (html = "") => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };

    const decodeHtmlEntities = (str = "") => {
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    };


    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const columns = [
        {
            name: 'Case Number',
            selector: row => row?.diagnosisid ?? "",
            // quick link to the case this image belongs to - opens view case in a new tab
            cell: (props) => props?.caseid ? (
                <a
                    href={`/viewcase/${props.caseid}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="case-number-badge"
                    title="Open case in new tab"
                >
                    {props?.diagnosisid || "View case"}
                    <span className="case-link-icon"><i className="mdi mdi-arrow-top-right"></i></span>
                </a>
            ) : (props?.diagnosisid || "—"),
            ignoreRowClick: true,
            width: "13.14%",
        },
        {
            name: 'Diagnosis',
            selector: row => toPlainText(row?.diagnosis),
            width: "13.14%",
        },
       






        {
            name: 'Status',
            selector: row => row?.isExpired ? "Expired" : "Active",
            cell: (props) =>
                <span
                    className="badge rounded-pill share-status-badge"
                    style={props?.isExpired
                        ? { backgroundColor: "#fde8e8", color: "#c81e1e", border: "1px solid #f8b4b4" }
                        : { backgroundColor: "#def7ec", color: "#046c4e", border: "1px solid #84e1bc" }}
                >
                    {props?.isExpired ? "Expired" : "Active"}
                </span>,
            width: "13.14%",
        },
     

        // hidden for now - still shown on view/edit
        // {
        //     name: 'Created on',
        //     selector: row => row?.created,
        //     cell: (props) => props?.created ? dateFormat(props?.created) : "",
        //     // sortFunction: (a, b) => moment(a.created).diff(b.created),
        //     width: "11.5%",
        // },

        {
            name: 'Updated on',
            selector: row => row?.updated,
            cell: (props) => props?.updated ? dateFormat(props?.updated) : "",
            width: "13.14%",
        },

        {
            name: 'Expires In',
            selector: row => getTimeLeft(row, now).label,
            cell: (props) => {
                const { label, tone } = getTimeLeft(props, now);
                return (
                    <span className={`time-left time-left-${tone}`}>
                        <i className={`mdi ${tone === "expired" ? "mdi-timer-off-outline" : "mdi-timer-sand"}`}></i>
                        {label}
                    </span>
                );
            },
            width: "13.14%",
        },

        {
            name: 'Created By',
            selector: row => row?.createdByName || row?.createdBy?.username || "",
            width: "13.14%",
        },
        {
            name: 'Image',
            cell: (props) => {
                if (!imageCloudfront || getPreviewCandidates(props, imageCloudfront).length === 0) return "";
                return (
                    <div
                        className="share-thumb-wrap"
                        title="View image"
                        onClick={() => setViewerImage({ tileSource: getViewerTileSource(props, imageCloudfront), title: props?.diagnosisid })}
                    >
                        <ShareThumb
                            row={props}
                            imageCloudfront={imageCloudfront}
                            width={120}
                            className="share-thumb"
                            fallback={<span className="share-thumb share-thumb-empty"><i className="mdi mdi-image-off-outline"></i></span>}
                        />
                        <span className="share-thumb-overlay">
                            <i className="mdi mdi-eye"></i>
                        </span>
                    </div>
                );
            },
            ignoreRowClick: true,
            width: "8%",
        },
           {
            name:

                'Actions'
            ,
            cell: (props) =>
                //   {

                <div className="d-flex">


                    <a onClick={(e) => handleViewShare(e, props)}
                        className="text-success action-button"
                        title="View"
                    >
                        <i className="mdi mdi-eye font-size-18"></i>
                    </a>

                    <a onClick={() => setShareRow(props)}
                        className="action-button share-action-button"
                        title="Share link"
                    >
                        <i className="mdi mdi-share-variant font-size-18"></i>
                    </a>

                    <a onClick={(e) => handleEditUser(e, props)}
                        // className='text-danger action-button'
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}><i
                            className="mdi mdi-pencil font-size-18"></i> </a>

                    {/* delete hidden for now - it still calls caseDelete, which removes the whole case
                    <a onClick={(e) => handleDeleteUser(e, props)}
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}><i
                            className="mdi mdi-delete font-size-18"></i> </a>
                    */}

                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: "13.14%",
        },


    ];



    const dateFormat = (created) => {

        const dateObj = new Date(created);

        // Extract date parts in IST
        const day = dateObj.toLocaleString('en-GB', { day: '2-digit', timeZone: 'Asia/Kolkata' });
        const month = dateObj.toLocaleString('en-GB', { month: '2-digit', timeZone: 'Asia/Kolkata' });
        const year = dateObj.toLocaleString('en-GB', { year: 'numeric', timeZone: 'Asia/Kolkata' });

        // Extract time parts in IST with AM/PM
        const time = dateObj.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'Asia/Kolkata'
        });

        // Combine date and time
        const formattedDateTime = `${day}-${month}-${year} ${time}`;
        return formattedDateTime.toUpperCase();
    }


    const handlePageChange = (page) => {
        // the data table re-fires this on mount (React StrictMode) - ignore when nothing changed
        if (page === currentPageNew) return;
        GetTimeActivity()
        setCurrentPage(page);
        fetchCases({ page, search: activeSearch, showLoader: false });
    };

    const handlePerRowsChange = (newPerPage) => {
        if (newPerPage === rowsPerPage) return;
        GetTimeActivity()
        setRowsPerPage(newPerPage);
        setCurrentPage(1);
        fetchCases({ page: 1, perPage: newPerPage, search: activeSearch, showLoader: false });
    };


    // useEffect(() => {
    //     setRoute("user")
    //     // setActiveMenuId(200003)
    //     setData([])
    //     // userActivity();
    //     if (!localStorage.getItem("token")) {
    //         navigate("/");
    //     }
    // }, []);
    useEffect(() => {
        console.log("🔁 useEffect triggered");

        setRoute("user");
        console.log("📍 Route set to: user");

        setData([]);
        console.log("🧹 Data reset");

        const token = localStorage.getItem("token");
        console.log("🔐 Token:", token);

        if (!token) {
            console.log("🚫 No token found, navigating to login");
            navigate("/");
            return;
        }

        // coming back from edit/view restores the saved page; from any other menu start on page 1
        // (currentPageNew is shared context and may still hold another menu's page)
        const savedPosition = state?.restoreListPage ? getSavedListPosition() : null;
        if (savedPosition) {
            setRowsPerPage(savedPosition.perPage);
            setCurrentPage(savedPosition.page);
            User(savedPosition.page, savedPosition.perPage);
        } else {
            setCurrentPage(1);
            User(1);
        }
    }, []);



    // useEffect(() => {
    //     if (searchedFlag) {
    //         handleSearch();
    //     } else {
    //         User();
    //     }

    // }, [searchedFlag]);


    // single fetch for the list and search
    const fetchCases = ({ page = 1, perPage = rowsPerPage, search = "", showLoader = true }) => {
        const requestId = ++requestIdRef.current;
        showLoader ? setIsLoading(true) : setTableLoading(true)
        tmdbApi.getAllShareCaseDetails({ page, pageSize: perPage, search })
            .then(function (response) {
                // a newer request went out while this one was in flight - drop this response
                if (requestId !== requestIdRef.current) return;

                if (response?.result === "Invalid token or Expired") {
                    setIsLoading(false)
                    setTableLoading(false)
                    setShowSessionPopupup(true)
                    //                 localStorage.clear();
                    //    navigate("/")
                } else {
                    const result = response?.result;
                    const rows = Array.isArray(result)
                        ? result
                        : Array.isArray(result?.data)
                            ? result.data
                            : Array.isArray(result?.questionData)
                                ? result.questionData
                                : null;

                    if (!rows) {
                        throw new Error("Unexpected shared links response: expected result.data to be an array");
                    }

                    // page is past the end (e.g. last row on the page was deleted) - step back one page
                    if (rows.length === 0 && page > 1) {
                        setCurrentPage(page - 1)
                        fetchCases({ page: page - 1, perPage, search, showLoader })
                        return
                    }

                    setData(rows);
                    global.exportExcelData = rows
                    setTotalRows(Number(result?.totalCount ?? response?.totalCount ?? rows.length));
                    setActiveSearch(search);

                    setIsLoading(false);
                    setTableLoading(false);
                }
            }).catch((err) => {
                if (requestId !== requestIdRef.current) return;
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
                setTableLoading(false);
            });
    }

    const User = (page = currentPageNew, perPage = rowsPerPage, showLoader = true) => {
        fetchCases({ page, perPage, showLoader });
    }

    const handleSearch = () => {
        GetTimeActivity();

        // ✅ Empty / whitespace-only validation
        if (usersearch.trim().length === 0) {
            toast.error("Search field cannot be empty.");
            return;
        }

        setCurrentPage(1);
        fetchCases({ page: 1, search: usersearch });
    };

    const handleChange = (e) => {
        setUserSearch(e.target.value)
    }

    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        GetTimeActivity()
        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };

    const handleAddUser = (e) => {
        navigate("/addcase");
    }

    // const handleEditUser = (e, paramuserid) => {
    //     console.log('paramuserid', paramuserid)
    //     // navigate("/editcase/" + paramuserid);
    //     // navigate("/editcase/" + paramuserid, {
    //     //     state: { searchQuery: usersearch }
    //     // });
    //     if (usersearch.trim().length > 0) {
    //         localStorage.setItem('caseSearchQuery', usersearch);
    //     }
    //     navigate("/editcase/" + paramuserid);
    // }
    // list position goes to localStorage so returning from view/edit restores the page
    const saveListPosition = () => {
        localStorage.setItem("shareHistoryListPosition", JSON.stringify({ page: currentPageNew, perPage: rowsPerPage }));
    };

    const getSavedListPosition = () => {
        try {
            const saved = JSON.parse(localStorage.getItem("shareHistoryListPosition"));
            return saved?.page && saved?.perPage ? saved : null;
        } catch {
            return null;
        }
    };

    // row goes in navigate state so view/edit can fall back to it when the api has no data
    const handleViewShare = (e, row) => {
        e.preventDefault();
        saveListPosition();
        navigate(`/sharedlinks/view/${row.shareid}`, { state: { shareData: row } });
    };

    const handleEditUser = (e, row) => {
        e.preventDefault();
        saveListPosition();
        navigate(`/sharedlinks/edit/${row.shareid}`, { state: { shareData: row } });
    };

    // const handleDeleteUser = (e, row) => {
    //     const hasModules = Array.isArray(row?.caseModules) && row.caseModules.length > 0;
    //     if (hasModules) {
    //         setDeleteBlocked(true);
    //     } else {
    //         setDeleteUserId(row.caseid)
    //         setDeleteShow(true)
    //     }
    // }

    // const onDeleteCancel = (e) => {
    //     setDeleteShow(false)
    //     setDeleteUserId(null)
    // }

    // const handleDelete = async (e) => {
    //     setDeleteShow(false)
    //     try {
    //         await tmdbApi.caseDelete(deleteUserId);
    //         setDeleteUserId(null)
    //         // reload the page the user is on (search or not)
    //         fetchCases({ page: currentPageNew, search: activeSearch });
    //         setToastMessage("Deleted Successfully")
    //     } catch {
    //         console.log("error");
    //     }
    // }


    const clearSearch = () => {
        GetTimeActivity()
        setUserSearch("");
        setCurrentPage(1);
        User(1);
    }

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No data were found</p>
                </div> </div>
        )
    }


    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper" className="create-case-db">
                <Header />
                <SideMenu />

                {/* Start right Content here  */}

                <div className="main-content user-management create-case share-history" id="main-content">
                    <div className="page-content create-case-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">SHARED LINKS</h4>
                                        </div>

                                        <div className="d-flex gap-2">

                                            


                                        </div>


                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            {isLoading ? <Loader /> : <>
                                                <div className="row justify-content-end align-items-end" id="table-header-row">
                                                    <div className="col-sm-12 col-md-7 col-lg-8">
                                                        <div className="search-box d-inline-block" id="search-box">
                                                            <div className="position-relative">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={usersearch}
                                                                    onChange={(e) => handleChange(e)}
                                                                    placeholder="Search by Case Number"
                                                                    onKeyPress={handleKeypress}
                                                                    id="search-input"
                                                                />
                                                                <button
                                                                    className="fill_btn"
                                                                    onClick={handleSearch}
                                                                    id="search-btn">
                                                                    <span className="material-icons search-icon">search</span>
                                                                </button>
                                                            </div>
                                                            <div className="dataTables_length" id="datatable-length-reset">
                                                                <button
                                                                    className="fill_btn"
                                                                    onClick={clearSearch}
                                                                    id="reset-btn">
                                                                    <span className="material-icons-outlined">sync</span>Reset
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="text-sm-end" id="text-end"></div>
                                                    </div>
                                                </div>

                                                <DataTable
                                                    key={keyForRerender}
                                                    columns={columns}
                                                    className="case-table"
                                                    keyField='_id'
                                                    data={data}
                                                    direction="auto"
                                                    highlightOnHover
                                                    fixedHeaderScrollHeight="300px"
                                                    pagination
                                                    paginationServer
                                                    progressPending={tableLoading}
                                                    progressComponent={<TableLoader />}
                                                    responsive
                                                    persistTableHead
                                                    striped
                                                    subHeaderAlign="right"
                                                    noDataComponent={customNoRecords()}
                                                    paginationTotalRows={totalRows}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    paginationPerPage={rowsPerPage}
                                                    paginationDefaultPage={currentPageNew}
                                                    paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                    paginationComponentOptions={{
                                                        rowsPerPageText: 'Per page:',
                                                        rangeSeparatorText: 'of',
                                                        noRowsPerPage: false,
                                                        selectAllRowsItem: false,
                                                        selectAllRowsItemText: 'All',
                                                    }}

                                                    id="data-table"
                                                />

                                            </>}

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert>


                    {/* <SweetAlert
                        show={deleteBlocked}
                        warning
                        confirmBtnText="Close"
                        confirmBtnBsStyle="danger"
                        title="Cannot Delete Case"
                        onConfirm={() => setDeleteBlocked(false)}
                    >
                        This case is currently assigned to one or more modules and cannot be deleted. Please unassign the modules before deleting.
                    </SweetAlert>

                    <SweetAlert
                        show={deleteShow}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure you want to delete?"
                        focusCancelBtn
                        onConfirm={e => handleDelete(e)}
                        onCancel={e => onDeleteCancel(e)}
                    >
                    </SweetAlert> */}
                    {/* ✅ Toast container should be here */}
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        pauseOnHover
                        draggable
                    />


                    <Footer id="footer" />
                </div>

                <ShareLinkModal
                    row={shareRow}
                    onHide={() => setShareRow(null)}
                    onExtend={(row) => {
                        // extend flow lives on the edit page
                        saveListPosition();
                        navigate(`/sharedlinks/edit/${row.shareid}`, { state: { shareData: row } });
                    }}
                />

                {viewerImage && (
                    <ShareImageViewer
                        tileSource={viewerImage.tileSource}
                        title={viewerImage.title}
                        onClose={() => setViewerImage(null)}
                    />
                )}





            </div>
            <style>
                {`
                    #main-content.share-history .rdt_Table .rdt_TableHeadRow .rdt_TableCol, #main-content.share-history .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
                            flex: 0 0 13.14% !important;
                            min-width: 13.14% !important;
                            max-width: 13.14% !important;
                        }
                        #main-content.share-history .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-last-child(2), #main-content.share-history .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-last-child(2) {
                            flex: 0 0 8% !important;
                            min-width: 8% !important;
                            max-width: 8% !important;
                        }
                        #main-content.share-history .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .share-status-badge {
                            font-size: 12px;
                            font-weight: 600;
                            padding: 6px 14px;
                            min-width: 72px;
                        }
                        #main-content.share-history .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
                            align-items: center;
                        }
                        #main-content.share-history .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .case-number-badge {
                            display: inline-flex;
                            align-items: center;
                            gap: 8px;
                            padding: 3px 3px 3px 12px;
                            border-radius: 999px;
                            background-color: #fff;
                            border: 1px solid #F2A341;
                            color: #1E222B;
                            font-size: 12px;
                            font-weight: 700;
                            letter-spacing: 0.2px;
                            text-decoration: none;
                            white-space: nowrap;
                            box-shadow: 0 1px 2px rgba(242, 163, 65, 0.25);
                            transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
                        }
                        #main-content.share-history .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .case-number-badge .case-link-icon {
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            width: 20px;
                            height: 20px;
                            border-radius: 50%;
                            background-color: #F2A341;
                            color: #fff;
                            font-size: 12px;
                            line-height: 1;
                            transition: background-color 0.2s ease, color 0.2s ease;
                        }
                        #main-content.share-history .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .case-number-badge:hover {
                            background-color: #F2A341;
                            color: #fff;
                            box-shadow: 0 3px 8px rgba(242, 163, 65, 0.4);
                            transform: translateY(-1px);
                        }
                        #main-content.share-history .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .case-number-badge:hover .case-link-icon {
                            background-color: #fff;
                            color: #F2A341;
                        }
                        #main-content.share-history .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .d-flex .action-button.share-action-button {
                            border-radius: 0;
                            margin-left: -1px;
                        }
                        #main-content.share-history .time-left {
                            display: inline-flex;
                            align-items: center;
                            gap: 4px;
                            font-size: 12px;
                            font-weight: 600;
                            white-space: nowrap;
                        }
                        #main-content.share-history .time-left .mdi {
                            font-size: 14px;
                            line-height: 1;
                        }
                        #main-content.share-history .time-left-ok { color: #046c4e; }
                        #main-content.share-history .time-left-soon { color: #d97706; }
                        #main-content.share-history .time-left-urgent { color: #c81e1e; }
                        #main-content.share-history .time-left-expired { color: #9ca3af; font-weight: 500; }
                        #main-content.share-history .time-left-none { color: #9ca3af; }
                        #main-content.share-history .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .share-thumb-wrap {
                            position: relative;
                            display: inline-block;
                            cursor: pointer;
                            border-radius: 4px;
                            overflow: hidden;
                        }
                        #main-content.share-history .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell img.share-thumb {
                            display: block;
                            width: 56px;
                            height: 40px;
                            object-fit: cover;
                            border: 1px solid #d3d3d3;
                            border-radius: 4px;
                        }
                        #main-content.share-history .share-thumb-empty {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 56px;
                            height: 40px;
                            border: 1px solid #d3d3d3;
                            border-radius: 4px;
                            background: #f3f4f6;
                            color: #9ca3af;
                            font-size: 18px;
                        }
                        #main-content.share-history .share-thumb-overlay {
                            position: absolute;
                            inset: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: rgba(0, 0, 0, 0.35);
                            color: #fff;
                            font-size: 18px;
                            transition: background 0.2s ease;
                        }
                        #main-content.share-history .share-thumb-wrap:hover .share-thumb-overlay {
                            background: rgba(0, 0, 0, 0.6);
                        }
                        .user-management .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell div:first-child {text-align: start;}
                    `}
            </style>
        </>
    );
};

export default ShareHistory;